export default "__VITE_ASSET__D6bFUx$C__"